/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import AddNoteContainer from './note.add.container';

class ModalAddNote extends React.Component {
  render() {
    return (
      <div id="add-note-modal">
        <AddNoteContainer />
      </div>
    );
  }
}

export default ModalAddNote;
